<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import IconRounded from "@/Components/IconRounded.vue";

const props = defineProps({
	//records: Array,
	template: String,
	title: String,
	fileName: String,
	students: Object,
	classrooms: Object,
	ciclos: Object,
	isAdmin: Boolean,
	isCoord: Boolean,
	plantilla: String

});
const loading = ref(false)
const resource = ref('reportcalification')
const errors = ref({})
const error = ref('')
const form = ref({
	'id_student': 0,
	'id_classroom': 0,
	'id_classroom_ugel': 0,
	'id_ciclo': 0,
	'is_sort_nombre': false,
	'sort_nombre': false,
	'is_sort_puntaje': false,
	'sort_puntaje': false,
})
const filters = ref([])
const records = ref([])
//const id_classroom = ref(0)
//const id_ciclo= ref(0)

const getRecords = async () => {
	if (props.template == 'calificationsugel') {
		if (form.value.id_classroom_ugel == 0 || !form.value.id_ciclo) {
			//this.$message.error('Seleccionar estudante');
			if (!form.value.id_classroom_ugel) error.value = 'Debe escoger un aula'
			if (!form.value.id_ciclo) error.value += ' Debe escoger un periodo'
			return false;
		} else {
			error.value = '';
		}
	} else {
		if (form.value.id_classroom == 0 || !form.value.id_ciclo) {
			//this.$message.error('Seleccionar estudante');
			if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
			if (!form.value.id_ciclo) error.value += ' Debe escoger un periodo'
			return false;
		} else {
			error.value = '';
		}
	}

	loading.value = true;
	records.value = [];
	await axios.post(`/${resource.value}/records`, form.value)
		.then(response => {
			records.value = response.data;
		});
	loading.value = false;
}

const sortNombre = () => {
	form.value.is_sort_nombre = true;
	form.value.is_sort_puntaje = false;
	form.value.sort_nombre = !form.value.sort_nombre;
	getRecords();
}

const exportFile = async (format) => {
	loading.value = true;
	// this.loadingSubmit = true;
	errors.value = {};
	console.log('cr_ugel ' + form.value.id_classroom_ugel)
	console.log('cr ' + form.value.id_classroom)
	await axios({
		url: `/${resource.value}/export`,
		method: 'POST',
		responseType: 'blob',
		data: {
			'records': records.value,
			'format': format,
			'template': props.template,
			'id_classroom': form.value.id_classroom ?? form.value.id_classroom_ugel,
			//'id_classroom_ugel': form.value.id_classroom_ugel,
			'id_ciclo': form.value.id_ciclo
		}
	}).then(response => {
		let res = response.data;
		if (res.type === 'application/json') {
			//this.$message.error('Error al exportar');
			console.log('Error al exportar')
		} else {
			const url = window.URL.createObjectURL(new Blob([res]));
			const link = document.createElement('a');
			link.href = url;
			//link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
			if (format == 'preview') {
				link.target = "_blank";
				link.setAttribute('view', props.fileName + '.html');
			} else {
				link.setAttribute('download', props.fileName + '.' + format);
			}
			document.body.appendChild(link);
			link.click();
		}
	}).catch(error => {
		console.log(error);
		errors.value = error;
	}).then(() => {
		loading.value = false;
	});
	// this.loadingSubmit = false;
	//

}

const number2nota = (notaN) => {
	let nota = parseFloat(notaN).toFixed(2);
	let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
	//console.log(nota)
	return result
}
</script>

<template>
	<Head :title="title" />

	<BreezeAuthenticatedLayout>


		<template #header>
        <PremiumPageHeader :title="title" :subtitle="'Gestión de ' + title">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
            </template>
        </PremiumPageHeader>
    </template>


		<div>
				<div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
					<!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
					<!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->
					<div class="mb-4">
						<li>Tomar en cuenta que la información puede variar si actualizan las calificaciones luego de descargar el reporte.
							<BaseIcon :path="mdiInformationOutline" size="15" title="La nota Nivel de logro se calcula como la siguiente fórmula;
                              Nota menor a 10.5 = C, Nota mayor o igual a 10.50 y menor a 3.50 = B, Nota mayor o igual a 13.50 y menor a 7.50 = A,
                              Nota mayor o igual a 17.50 y menor a 20 = AD,
                              cualquier otro dato mostrará  Error = E" />
						</li>
						<li>Sólo se muestran alumnos activos</li>
					</div>

					<div class="grid grid-cols-1 gap-3 md:grid-cols-4">

						<div class="relative">
							<label class="block font-bold mb-2 ml-2">Bimestre</label>
							<select v-model="form.id_ciclo" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
								<option value="0" selected>Todos</option>
								<option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
							</select>
						</div>

						<div v-if="template != 'calificationsugel'" class="relative">
							<label class="block font-bold mb-2 ml-2">Aula de estudio</label>
							<select v-model="form.id_classroom" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
								<option value="0" selected>Todas</option>
								<option v-for="option in classrooms" :value="option.id">{{ option.label }}</option>
							</select>
						</div>
						<div v-if="template == 'calificationsugel'" class="relative">
							<label class="block font-bold mb-2 ml-2">Aula UGEL</label>
							<select v-model="form.id_classroom_ugel" @change="getRecords()" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
								<option value="0" selected>Todas</option>
								<option v-for="option in classrooms" :value="option.id">{{ option.label }}</option>
							</select>
						</div>

					</div>
					<div class="mt-4">
						<div class="relative">
							<label class="block font-bold mb-2 ml-1">Estudiante</label>
							<select v-model="form.id_student" @change="getRecords()" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
								<option value="0" selected>Todos</option>
								<option v-for="option in students" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
							</select>
						</div>
					</div>

					<div class="mt-4"> <!-- v-if="records.length" -->
						<!-- <div class="inline-block pr-2 ml-1" @click="exportFile('pdf')">
                            Exportar
                            <IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800"
                             /> 
                          </div> -->
						<div class="inline-block ml-4" v-if="$page.props.auth.user.id_rol == 1">
							<BaseButton :disabled="records.length <= 0" @click="exportFile('preview')" color="info" :icon="mdiFileTableOutline" label="Vista previa" small target="_blank" />
						</div>
						<div class="inline-block ml-4">
							<BaseButton :disabled="records.length <= 0" @click="exportFile('xlsx')" color="success" :icon="mdiFileTableOutline" label="Exportar" small target="_blank" />
						</div>
						<!-- <div v-if="modulo=='payementOrder' && showDownloadTxt && countChecked" class="inline-block">
                            <IconRounded color="" :icon="mdiFileDocument" title="Exportar a txt" class="ml-1 text-blue-700"
                            @click="exportFile('txt')" />
                          </div> -->
					</div>


					<CardBox v-if="records.length" class="mb-6" has-table>
						<!-- Tablesingle opciones: checkable -->
						<div class="w-full overflow-x-auto">
							<table class="table-responsive">
								<thead>
									<tr>
										<th>#</th>
										<th @click="sortNombre">Nombre
											<i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
											<i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
											<i v-else class="fas fa-sort"></i>
										</th>
										<th>Bimestre</th>
										<th>Curso</th>

										<th title="Promedio Antes del Simulacro">Promedio A.S.</th>
										<th title="Resultado de Simulacro">R. Simulacro</th>
										<th title="Promedio después del Simulacro">Promedio D.S</th>
										<th>Nivel de logro</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, index) in records" :key="row.id">
										<td data-label="#">
											{{ index + 1 }}
										</td>
										<td data-label="Nombre">
											{{ row.fullname }}
										</td>
										<td data-label="Bimestre">
											{{ row.ref_ciclo }}
										</td>
										<td data-label="Curso">
											{{ row.label_short_course ? row.label_short_course : row.label_course }}
										</td>

										<td data-label="Promedio A.S.">
											{{ row.promedio }}
										</td>
										<!--<td data-label="Progress" class="lg:w-32">
                                    <progress
                                        class="flex w-2/5 self-center lg:w-full"
                                        max="100"
                                        :value="row.progress"
                                    >
                                        {{ row.progress }}
                                    </progress>
                                    </td>
                                    -->
										<td data-label="R. Simulacro" class="lg:w-1 whitespace-nowrap">
											<small :class="(row.simulacro_admision < 1 ? 'text-red-600' : (row.simulacro_admision == 1 ? 'text-green-600' : ''))" :title="row.simulacro_admision">{{ (row.simulacro_admision == 1 ? 'Aprobado' : (row.simulacro_admision == 2 ? 'Ausente' : 'Desaprobado')) }}
											</small>
										</td>
										<td data-label="Promedio D.S">
											{{ row.promediods }}

										</td>

										<td data-label="Nivel de logro">
											{{ number2nota(row.promediods) }}

										</td>
									</tr>
								</tbody>
							</table>
						</div>

					</CardBox>
					<CardBox v-else>
						<CardBoxComponentEmpty />
					</CardBox>
				</div>
		</div>

	</BreezeAuthenticatedLayout>
</template>